import React from 'react';
import { connect } from 'react-redux';

import { clearFilter, sortPartnerOnOrder } from '../../../services/filter/actions';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { withTemplate } from '../../template/withTemplate';
import { HeadComponent } from '../../HeadComponent';
import DirectoryPage from './DirectoryPage';

export class MostPopularDirectoryPage extends React.Component {
    render() {
        const { match, isCodePromo = false, i18nPage } = this.props;
        return (
            <div>
                <HeadComponent title={i18nPage.TITLE} description={i18nPage.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={match.url}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <DirectoryPage letter={match.params.letter || ''} isCodePromo={isCodePromo} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.DIRECTORY.MOST_POPULAR
    };
};

const mapDispatchToProps = {
    clearFilter,
    sortPartnerOnOrder
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(MostPopularDirectoryPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/directory/MostPopularDirectoryPage.js